<template>
  <div>
    <div class="mb-6"></div>
    <v-skeleton-loader
      class="title--loader px-6"
      type="chip"
    ></v-skeleton-loader>
    <div class="mb-6"></div>
    <v-skeleton-loader
      class="desc--loader px-6"
      type="chip"
    ></v-skeleton-loader>
    <div class="mb-6"></div>
    <v-row no-gutters>
      <v-col cols="6" class="px-6">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="6" class="pr-6">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <div class="mb-6"></div>
    <v-row no-gutters>
      <v-col cols="4" class="px-6">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="4">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="4" class="px-6">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <div class="mb-6"></div>
    <v-row no-gutters>
      <v-col cols="12" class="px-6">
        <v-skeleton-loader
          class="details--loader"
          type="chip"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <div class="mb-6"></div>
  </div>
</template>

<script>
export default {
  name: 'VideoDetailsLoader',
}
</script>
<style lang="scss" scoped>
.v-skeleton-loader.v-skeleton-loader--is-loading.title--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 56px !important;
    width: auto !important;
  }
}
.v-skeleton-loader.v-skeleton-loader--is-loading.desc--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 158px !important;
    width: 100% !important;
  }
}
.v-skeleton-loader.v-skeleton-loader--is-loading.details--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 56px !important;
    width: 100% !important;
  }
}
</style>
